export default function ScoreboardSection() {
  const teams = [
    { id: 1, name: '115', logo: '🦅', color: 'bg-blue-600' },
    { id: 2, name: 'Tim Keshian', logo: '🎯', color: 'bg-red-600' },
    { id: 3, name: 'Adam Davis', logo: '💎', color: 'bg-purple-600' },
    { id: 4, name: 'Christian Narvios', logo: '⭐', color: 'bg-yellow-600' },
    { id: 5, name: 'Brian Hunt', logo: '👑', color: 'bg-orange-600' }
  ];

  // Sample scores for 7 weeks
  const weeklyScores = {
    1: [107, 103, 110, 156, 0],
    2: [115, 92, 102, 135, 118],
    3: [128, 106, 104, 150, 0],
    4: [128, 115, 106, 160, 0],
    5: [114, 98, 97, 160, 0],
    6: [115, 91, 107, 163, 0],
    7: [115, 69, 106, 0, 0]
  };

  const courseNames = [
    'Torrey Pines - South',
    'TPC Scottsdale',
    'King & Bear',
    'TPC Sawgrass',
    'Pebble Beach GC',
    'Innisbrook GC',
    'Kiawah Island GC'
  ];

  const courseDetails = [
    'Par 72 • 7,258 yards',
    '',
    '',
    '',
    '',
    '',
    ''
  ];

  const calculateTotal = (teamIndex: number) => {
    return Object.values(weeklyScores).reduce((total, week) => total + week[teamIndex], 0);
  };

  return (
    <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            League Standings
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Track the competition as players battle for the Winter League Championship
          </p>
        </div>

        {/* Weekly Scores Table */}
        <div id="weekly-scoreboard" className="bg-white rounded-xl shadow-lg overflow-hidden">
          <div className="bg-green-600 text-white p-6">
            <h3 className="text-2xl font-bold flex items-center">
              <i className="ri-calendar-line mr-3"></i>
              Weekly Scoreboard
            </h3>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-4 text-left font-semibold text-gray-900">Player</th>
                  {courseNames.map((course, index) => (
                    <th key={index} className="px-4 py-4 text-center font-semibold text-gray-900 min-w-[140px]">
                      <div className="text-center">Week {index + 1}</div>
                      <div className="text-xs font-normal text-gray-600 mt-1 text-center">{course}</div>
                      {courseDetails[index] && (
                        <div className="text-xs font-normal text-gray-600 text-center">{courseDetails[index]}</div>
                      )}
                    </th>
                  ))}
                  <th className="px-6 py-4 text-center font-semibold text-gray-900">Total</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {teams.map((team, index) => (
                  <tr key={team.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-3">
                        <div className={`w-10 h-10 ${team.color} rounded-full flex items-center justify-center text-white text-lg`}>
                          {team.logo}
                        </div>
                        <div>
                          <div className="font-semibold text-gray-900">{team.name}</div>
                        </div>
                      </div>
                    </td>
                    {[1, 2, 3, 4, 5, 6, 7].map(week => (
                      <td key={week} className="px-4 py-4 text-center">
                        <div className="flex justify-center">
                          <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-green-100 text-green-800">
                            {weeklyScores[week][index]}
                          </span>
                        </div>
                      </td>
                    ))}
                    <td className="px-6 py-4 text-center">
                      <div className="flex justify-center">
                        <span className="inline-flex items-center px-4 py-2 rounded-full text-lg font-bold bg-green-600 text-white">
                          {calculateTotal(index)}
                        </span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* League Info */}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white rounded-xl p-6 shadow-lg text-center">
            <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-calendar-check-line text-white text-2xl"></i>
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-2">7 Week Season</h4>
            <p className="text-gray-600">Weekly Matches</p>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-lg text-center">
            <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-golf-ball-line text-white text-2xl"></i>
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-2">Stroke Play</h4>
            <p className="text-gray-600">Lowest score leads</p>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-lg text-center">
            <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-trophy-line text-white text-2xl"></i>
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-2">Championship</h4>
            <p className="text-gray-600">Winner takes the trophy</p>
          </div>
        </div>
      </div>
    </section>
  );
}
